/*
  Foxkit cart bridge.

  The Foxkit "Buy more save more" widget adds to the cart through its own POST /cart/add.js and
  then applies the bundle discount with a trailing POST /cart/update. Neither call goes through the
  theme's product form, so `cascade:modalcart:afteradditem` never fires: the item really is in the
  cart, but the drawer does not open and the header badge, the drawer line items and the drawer
  footer all stay stale. The add looks to the shopper like it failed.

  Foxkit publishes its own event bus (`window.FoxkitEvents`, subscribe / emit). This listens to it,
  re-renders the same three cart sections the theme's own add requests, and dispatches the theme's
  own event with the same payload shape, so every existing listener (cart-count.js, cart-items.js,
  cart-footer.js, modal-cart.js) updates exactly as it does after a normal add. No app code is
  patched and no theme handler is duplicated.
*/
(() => {
  // Same section list product.js appends to its /cart/add request.
  const SECTIONS = 'cart-items,cart-footer,cart-item-count';
  const SETTLE_MS = 600; // Foxkit applies the bundle discount in a trailing /cart/update.
  const THEME_WINDOW_MS = 2000;

  let themeHandledAt = 0;
  let lastAddAt = 0;
  let timer = null;

  // Foxkit's fetch wrapper reports every successful /cart/add, including the theme's own. When the
  // theme already handled the add, its listeners have run and there is nothing to repair.
  document.body.addEventListener('cascade:modalcart:afteradditem', (event) => {
    if (!event.detail || !event.detail.foxkit) themeHandledAt = Date.now();
  });

  function refresh() {
    if (Date.now() - themeHandledAt < THEME_WINDOW_MS) return;

    fetch(`${window.location.pathname}?sections=${SECTIONS}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => response.json())
      .then((sections) => {
        document.body.dispatchEvent(
          new CustomEvent('cascade:modalcart:afteradditem', {
            bubbles: true,
            detail: { foxkit: true, response: { sections } },
          })
        );
      })
      .catch(() => {
        // ponytail: a failed refresh leaves the cart exactly as it is today, so there is nothing
        // to roll back and nothing to tell the shopper that the cart itself does not already say.
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, SETTLE_MS);
  }

  function subscribe() {
    if (!window.FoxkitEvents || typeof window.FoxkitEvents.subscribe !== 'function') return false;

    window.FoxkitEvents.subscribe('ON_ITEM_ADDED', () => {
      lastAddAt = Date.now();
      schedule();
    });

    // The discount lands after the add. Re-run only while an add is in flight, so cart edits made
    // anywhere else keep using the theme's own quantity-change path untouched.
    window.FoxkitEvents.subscribe('ON_CART_UPDATE', () => {
      if (Date.now() - lastAddAt < 5000) schedule();
    });

    return true;
  }

  if (!subscribe()) {
    // The bus is created by the Foxkit app bundle, which loads after the theme assets.
    const poll = setInterval(() => {
      if (subscribe()) clearInterval(poll);
    }, 300);
    setTimeout(() => clearInterval(poll), 20000);
  }
})();
